<template>
  <div class="contentBox" :class="device=='mobile'?'mobileBox':''">
    <button class="btn btn-back" @click="goBack"></button>
    <web ref="web" class="webBox"></web>
    <p class="title">{{title}}</p>
    <div class="list">
      <div class="list-item">
        <div class="list-json">
          <div class="list-data" v-for="(ele,num) in listData" :key="num" @click="examSub(ele)" :class="ele.status==0?'unfinish':''">
            <p class="list-data-title">{{ele.big_title}}</p>
            <p class="list-data-status">{{ele.status == 0 ? '未完成':'已完成'}}</p>
            <!-- <span class="icon" v-if="num < item.list.length-1"></span> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getReadBigTopicList } from "@/assets/js/api";
import web from './../components/comment/web.vue';
export default {
  name: "login",
  data() {
    return {
      token:'',
      listData:[],
      device:'',
      title:''
    };
  },
  components: {
    web
  },
  mounted(){
    document.title = '习题刻意练习';
    var userData = JSON.parse(localStorage.getItem('identityData'));
    this.token = userData.apiToken;
    this.title = this.$route.query.title;
    this.getList();
    this.device = this.$refs.web.device;
    if(this.device == 'mobile'){
      this.$refs.web.font_resize();
    }
  },
  methods: {
    async getList(){
      var that = this;
      try {
        const response = await getReadBigTopicList({rmid:this.$route.query.rmid,week:this.$route.query.week,num:this.$route.query.num},this.token);
        if(response.code == 200){
          that.listData = response.data.list;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    examSub(e,i,item){
      var that = this;
      this.$router.push('/examTopic?rmid='+this.$route.query.rmid + '&rpid='+e.rpid+'&num='+this.$route.query.num)
    },

    goBack() {
      var that = this;
      that.$router.go(-1);
      setTimeout(function(){
        window.location.reload();
      },100)
    }
  },

  
};
</script>
<style scoped>
  .contentBox{
    background-image: url(~@/assets/images/index-bg.png);
    width: 100%;
    height: 100%;
    background-size: 100% 100%;
    padding: 101px 0 75px;
  }

  .title{
    color: #333333;
    font-size: 45px;
    display: block;
    font-weight: bold;
    text-align: center;
  }

  .btn-back{
    background-image: url(~@/assets/images/btn-bg1.png);
  }

  .list{
    font-size: 0;
    height: calc( 100% - 100px );
    overflow-y: auto;
    overflow-x: hidden;
  }

  .list .list-item{
    display: block;
    margin-bottom: 30px;
    padding: 0 60px;
    box-sizing: border-box;
  }

  .list-json,
  .list .list-item .list-title{
    font-size: 0;
  }

  .list .list-item .list-title p{
    color: #333333;
    font-size: 48px;
    display: inline-block;
    vertical-align: top;
  }

  .list .list-item .list-title .icon{
    background-image: url(~@/assets/images/icon4.png);
    width: 98px;
    height: 74px;
    background-size: 98px 74px;
    display: inline-block;
    vertical-align: top;
    margin-left: 18px;
  }

  .list .list-item .list-title .icon1{
    background-image: url(~@/assets/images/icon5.png);
    width: 73px;
    height: 74px;
    background-size: 73px 74px;
    display: inline-block;
    vertical-align: top;
    margin-left: 18px;
  }

  .list-data{
    padding: 45px 30px;
    box-sizing: border-box;
    border-radius: 30px;
    background: linear-gradient( 180deg, #BCD5FF 0%, #D7DBFF 65%);
    display: inline-block;
    vertical-align: top;
    margin-right: 50px;
    margin-bottom: 30px;
    position: relative;
  }

  .unfinish{
    background-image: url(~@/assets/images/bg5.png);
    background-size: 100% 100%;
  }

  .list-data-title{
    font-size: 36px;
    color: #333333;
    display: block;
    margin-bottom: 20px;
    text-align: center;
  }

  .list-data-status{
    color: #333333;
    font-size: 22px;
    background-color: #fff;
    border-radius: 30px;
    box-sizing: border-box;
    padding: 6px 37px;
    display: block;
  }

  .list-json{
    padding: 20px 141px 0;
    box-sizing: border-box;
  }

  .list-json .icon{
    background-image: url(~@/assets/images/icon7.png);
    width: 149px;
    height: 29px;
    background-size: 149px 29px;
    position: absolute;
    right: -149px;
    top: 50%;
    transform: translate(0,-50%);
  }

  .list-data-lock{
    background-image: url(~@/assets/images/icon6.png);
    width: 35px;
    height: 43px;
    background-size: 35px 43px;
    display: block;
    margin: 12px auto 0;
  }

  .mobileBox .title{
    font-size: .3rem;
  }

  .mobileBox .list{
    height: calc( 100% - .2rem );
    overflow-y: auto;
    overflow-x: hidden;
  }

  .mobileBox .list .list-item .list-title p{
    font-size: .24rem;
  }

  .mobileBox .list-data{
    padding: .16rem;
    margin-right: .83rem;
  }

  .mobileBox .list-data-title{
    font-size: .22rem;
  }

  .mobileBox .list-data-status{
    font-size: .14rem;
  }

  .mobileBox .list-json .icon{
    width: .83rem;
    height: .2rem;
    background-size: .83rem .2rem;
    right: -.83rem;
  }

  .mobileBox .list-json{
    padding: .1rem .6rem;
  }

  .mobileBox .btn-back{
    height: .52rem;
    width: .52rem;
    background-size: .52rem .52rem;
  }
</style>



// WEBPACK FOOTER //
// src/identity/examBigTopic.vue